export class GetBtmCarriersQuery {
    private readonly _warehouseCode: string;

    constructor(warehouseCode: string) {
        this._warehouseCode = warehouseCode;
    }

    get warehouseCode() {
        return this._warehouseCode;
    }
}
